'use strict';

var _ = require('lodash');
var ConfigurationEventsTransformerFactory = function ConfigurationEventsTransformerFactory($log, $rootScope, DataTransformer) {
  function ConfigurationEventsTransformerFactory() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-events-mode';
    this.priority = 1;
  }
  ConfigurationEventsTransformerFactory.prototype = Object.create(DataTransformer.prototype);
  ConfigurationEventsTransformerFactory.constructor = ConfigurationEventsTransformerFactory;
  ConfigurationEventsTransformerFactory.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationEventsTransformerFactory.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationEventsTransformerFactory.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationEventsTransformerFactory.prototype.transform = function (data) {
    var result = [];
    var inputData = data.domain._embedded;
    if (inputData && inputData.simpleFlattenedSpecialEventList[0]) {
      result = _.map(inputData.simpleFlattenedSpecialEventList, function (value) {
        return {
          eventId: value.eventId,
          eventName: value.name,
          eventType: value.type
        };
      });
    } else {
      $log.warn('ConfigurationEventsTransformer: incorrect data format from SimpleHEP');
    }
    $rootScope.$broadcast('configuration-events:loadedSuccessful', result);
    return result;
  };
  return ConfigurationEventsTransformerFactory;
};
ConfigurationEventsTransformerFactory.$inject = ['$log', '$rootScope', 'DataTransformerFactory'];
module.exports = ConfigurationEventsTransformerFactory;